module.exports = __webpack_public_path__ + "img/HC2021-83.63ffc055.jpg";